// Home.jsx

import React from "react";
import { Box } from "@mui/material";
import "./Home.css";
import CampaignHero from "../../../components/user-components/CampaignHero";
import SurveySection from "../../../components/user-components/survey/SurveySection";
import WhyImRunning from "../../../components/user-components/WhyImRunning";
import WhatIBelieve from "../../../components/user-components/WhatIBelieve";
import AboutCandidate from "../../../components/user-components/AboutCandidate";
import CampaignIssues from "../../../components/user-components/CampaignIssues";
import Issues from "../../../components/user-components/Issues";
import PetitionSection from "../../../components/user-components/PetitionSection";
import PrinciplesSection from "../../../components/user-components/PrinciplesSection";
import NeighborsSpeakSection from "../../../components/user-components/NeighborsSpeakSection";
import CampaignGallerySection from "../../../components/user-components/CampaignGallerySection";
import EventList from "../../../components/user-components/EventList";
import LegislationList from "../../../components/user-components/LegislationList";
import SupportCampaign from "../../../components/user-components/SupportCampaign";
import VolunteerSection from "../../../components/user-components/VolunteerSection";
import NewsSection from "../../../components/user-components/NewsSection";
import VotingSection from "../../../components/user-components/VotingSection";
import Footer from "../../../components/user-components/footer/Footer";
import DistrictMap from "../../../components/user-components/DistrictMap";
import ContactUs from "../../../components/user-components/ContactUs";
import ErrorBoundary from "../../../components/user-components/ErrorBoundary";

const Home = () => {
  return (
    <ErrorBoundary>
      {/* Sections */}
      <Box className="page-sections">
        <Box className="hero-section" id="home">
          <CampaignHero />
        </Box>

        <Box className="survey-section" id="survey">
          <SurveySection />
        </Box>

        <Box className="why-running-section" id="why-running">
          <WhyImRunning />
        </Box>

        <Box className="what-i-believe-section" id="beliefs">
          <WhatIBelieve />
        </Box>

        <Box className="about-candidate-section" id="about">
          <AboutCandidate />
        </Box>

        <Box className="campaign-issues-section" id="families">
          <CampaignIssues />
        </Box>

        <Box className="issues-section" id="issues">
          <Issues />
        </Box>

        <Box className="petition-section" id="petition">
          <PetitionSection />
        </Box>

        <Box className="principles-section" id="principles">
          <PrinciplesSection />
        </Box>

        <Box className="neighbors-speak-section" id="neighbors">
          <NeighborsSpeakSection />
        </Box>

        <Box className="campaign-gallery-section" id="photos">
          <CampaignGallerySection />
        </Box>

        <Box className="event-list-section" id="events">
          <EventList />
        </Box>

        <Box className="legist-list-section" id="legislation">
          <LegislationList />
        </Box>

        <Box className="district-map-section" id="district-map">
          <DistrictMap />
        </Box>

        <Box className="support-campaign-section" id="support">
          <SupportCampaign />
        </Box>

        <Box className="volunteer-section" id="volunteer">
          <VolunteerSection />
        </Box>

        <Box className="news-section" id="news">
          <NewsSection />
        </Box>

        <Box className="voting-section" id="voting">
          <VotingSection />
        </Box>

        <Box className="contact-us" id="contact-us">
          <ContactUs />
        </Box>

        <Box className="footer-section">
          <Footer />
        </Box>
      </Box>
    </ErrorBoundary>
  );
};

export default Home;
